require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./flexlayout"), require("./svgicon"), require("./tags"), require("./tooltip"), require("./truncatedtext"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./flexlayout", "./svgicon", "./tags", "./tooltip", "./truncatedtext", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./flexlayout"), require("./svgicon"), require("./tags"), require("./tooltip"), require("./truncatedtext"), require("./utils")) : factory(root["./button"], root["./flexlayout"], root["./svgicon"], root["./tags"], root["./tooltip"], root["./truncatedtext"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__37453__, __WEBPACK_EXTERNAL_MODULE__65391__, __WEBPACK_EXTERNAL_MODULE__47511__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[5540],{

/***/ 89047:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _tags = _interopRequireDefault(__webpack_require__(37453));
var _truncatedtext = _interopRequireDefault(__webpack_require__(47511));
var _flexlayout = _interopRequireWildcard(__webpack_require__(77765));
var _tooltip = _interopRequireDefault(__webpack_require__(65391));
var _overflowMenuHorizontal_ = _interopRequireDefault(__webpack_require__(16346));
var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(51443));
var _folder_ = _interopRequireDefault(__webpack_require__(70001));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
var _Tile = _interopRequireDefault(__webpack_require__(63893));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sanitize
} = _utils.propsUtils;
const tileClassName = _Tile.default.tileClassName.replace(/"/g, '');
class Tile extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_onContextMenu", e => {
      const {
        onMenu
      } = this.props;
      onMenu && onMenu(e);
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._buttonNode = node;
    });
  }
  _menuRenderer() {
    const {
      size,
      ellipsisIcon
    } = this.props;
    if (size === 'small') {
      return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        className: `${tileClassName}__footer__title`,
        orient: "bottom",
        title: this.props.ellipsisTooltipLabel,
        delay: true
      }, ellipsisIcon || /*#__PURE__*/_react.default.createElement(_button.default, {
        className: `${tileClassName}__footer__icon`,
        ref: this._ref,
        onClick: this._onContextMenu,
        variant: "inline",
        iconSize: "normal",
        icon: _overflowMenuHorizontal_.default.id
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      className: `${tileClassName}__header__title`,
      orient: "bottom",
      title: this.props.ellipsisTooltipLabel,
      delay: true
    }, ellipsisIcon || /*#__PURE__*/_react.default.createElement(_button.default, {
      className: `${tileClassName}__header__icon`,
      ref: this._ref,
      onClick: this._onContextMenu,
      variant: "inline",
      iconSize: "small",
      icon: _overflowMenuVertical_.default.id
    }));
  }
  render() {
    const {
      container,
      content,
      className,
      selected,
      onMenu,
      ellipsisIcon,
      size,
      textDir,
      dateLabel,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(tileClassName, size, {
      selected,
      container
    });
    if (container) {
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, (0, _extends2.default)({
        direction: "row",
        alignItems: "center"
      }, sanitize(others, Tile), {
        tabIndex: "0",
        className: `${classNames} ${className}`
      }), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
        className: `${tileClassName}__left`
      }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        className: `${tileClassName}__left__icon`,
        iconId: content.iconId || _folder_.default.id
      })), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
        grow: true,
        shrink: true
      }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
        direction: "column",
        justifyContent: "center",
        className: `${tileClassName}__middle`
      }, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
        className: `${tileClassName}__middle__label`,
        width: "100%",
        value: content.label,
        textDir: textDir
      })), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement("div", {
        className: `${tileClassName}__middle__date`
      }, content.date)))), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
        className: `${tileClassName}__right`
      }, (onMenu || ellipsisIcon) && this._menuRenderer())));
    }
    if (size === 'large') {
      const presetColors = ['red', 'magenta', 'purple', 'blue', 'cyan', 'teal', 'green', 'gray', 'coolgray', 'warmgray'];
      const tagColor = presetColors.indexOf(content.color) !== -1 ? content.color : 'coolgray';
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, (0, _extends2.default)({
        direction: "column"
      }, sanitize(others, Tile), {
        tabIndex: "0",
        onContextMenu: onMenu ? this._onContextMenu : null,
        className: `${classNames} ${className}`
      }), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
        alignItems: "center",
        justifyContent: "space-between",
        className: `${tileClassName}__header`
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        className: `${tileClassName}__icon__title`,
        orient: "top",
        title: content.type,
        delay: true
      }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        className: `${tileClassName}__header__type`,
        iconId: content.iconId,
        title: content.type,
        size: "large"
      })), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, (onMenu || ellipsisIcon) && this._menuRenderer()))), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
        grow: true,
        shrink: true,
        className: `${tileClassName}__body`
      }, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
        className: `${tileClassName}__body__label`,
        tooltipDelay: true,
        title: content.label,
        width: "100%",
        textDir: textDir,
        style: {
          maxWidth: '100%'
        },
        value: content.label
      }), /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        className: `${tileClassName}__body__tag`
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        orient: "right",
        title: content.type,
        delay: true
      }, /*#__PURE__*/_react.default.createElement(_tags.default, {
        tags: [{
          value: content.type,
          label: content.type,
          color: tagColor
        }],
        removable: false
      })))), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
        className: `${tileClassName}__footer__date`
      }, dateLabel, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
        tooltipDelay: true,
        title: content.date,
        width: "100%",
        value: content.date
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, (0, _extends2.default)({
      direction: "column"
    }, sanitize(others, Tile), {
      tabIndex: "0",
      onContextMenu: onMenu ? this._onContextMenu : null,
      className: `${classNames} ${className}`
    }), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      direction: "row",
      alignItems: "center",
      className: `${tileClassName}__header`
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      className: `${tileClassName}__icon__title`,
      orient: "top",
      title: content.type,
      delay: true
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: `${tileClassName}__header__icon`,
      iconId: content.iconId,
      title: content.type
    })), /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
      tooltipDelay: true,
      title: content.type,
      width: "100%",
      value: content.type
    }))), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true,
      shrink: true,
      className: `${tileClassName}__body`
    }, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
      tooltipDelay: true,
      title: content.label,
      width: "100%",
      textDir: textDir,
      value: content.label
    })), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      alignItems: "center",
      justifyContent: "space-between",
      className: `${tileClassName}__footer`
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      className: `${tileClassName}__date__title`,
      orient: "bottom",
      title: content.date,
      delay: true
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, content.date)), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, (onMenu || ellipsisIcon) && this._menuRenderer())))));
  }
}
exports["default"] = Tile;
(0, _defineProperty2.default)(Tile, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Select large or small size of the tile */
  size: _propTypes.default.string,
  /** Determines if the tile is an asset or a container (folder) */
  container: _propTypes.default.bool,
  /** Flag to select the tile */
  selected: _propTypes.default.bool,
  /** Data passed to tile */
  content: _propTypes.default.shape({
    type: _propTypes.default.string,
    iconId: _propTypes.default.string,
    label: _propTypes.default.string,
    date: _propTypes.default.string,
    color: _propTypes.default.string,
    value: _propTypes.default.any
  }).isRequired,
  /** Callback function for context menu */
  onMenu: _propTypes.default.func,
  /** Svg icon when loading context menu */
  ellipsisIcon: _propTypes.default.element,
  ellipsisTooltipLabel: _propTypes.default.string,
  dateLabel: _propTypes.default.string,
  /** Text direction */
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto'])
});
(0, _defineProperty2.default)(Tile, "defaultProps", {
  size: 'small',
  container: false,
  selected: false,
  className: '',
  ellipsisTooltipLabel: 'Action menu',
  dateLabel: 'Last modified'
});

/***/ }),

/***/ 75002:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Tile = _interopRequireDefault(__webpack_require__(89047));
exports["default"] = _Tile.default;
exports.Tile = _Tile.default;

/***/ }),

/***/ 14777:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-tile.is-container .ba-common-tile__middle__label,.ba-common-tile.is-large .ba-common-tile__body__label,.ba-common-tile.is-small .ba-common-tile__body{font-size:1rem;font-weight:400;line-height:1.25rem}.ba-common-tile.is-container .ba-common-tile__right,.ba-common-tile.is-container .ba-common-tile__middle__date,.ba-common-tile.is-container .ba-common-tile__left,.ba-common-tile.is-large .ba-common-tile__footer__date,.ba-common-tile.is-large .ba-common-tile__body__tag,.ba-common-tile.is-large .ba-common-tile__header,.ba-common-tile.is-small .ba-common-tile__footer,.ba-common-tile.is-small .ba-common-tile__header{font-size:.75rem;font-weight:400;line-height:1rem}.ba-common-tile *{cursor:pointer}.ba-common-tile{width:274px;padding:1px 16px;cursor:pointer}.ba-common-tile.is-selected{padding:0 15px;border-width:2px}.ba-common-tile .ba-common-tile__footer__icon:hover{color:#0f62fe}.ba-common-tile.is-small{background-color:#e0e0e0;height:140px}.ba-common-tile.is-small .ba-common-tile__header{height:48px;color:#161616}.ba-common-tile.is-small .ba-common-tile__header__icon{padding-right:8px}.ba-common-tile.is-small .ba-common-tile__body{color:#0f62fe}.ba-common-tile.is-small .ba-common-tile__footer{height:48px;color:#161616}.ba-common-tile.is-large{background-color:#e0e0e0;height:295px;width:295px;padding:8px 16px 16px 16px}.ba-common-tile.is-large .ba-common-tile__header{height:48px;color:#161616}.ba-common-tile.is-large .ba-common-tile__header__icon{transform:rotate(90deg)}.ba-common-tile.is-large .ba-common-tile__header svg.contextMenuButton{padding-top:0px !important;margin-right:-12px !important}.ba-common-tile.is-large .ba-common-tile__body{margin-top:12px;color:#161616}.ba-common-tile.is-large .ba-common-tile__body__label{font-size:24px;margin-bottom:8px;max-width:100%}.ba-common-tile.is-large .ba-common-tile__body__tag{height:16px;color:#161616}.ba-common-tile.is-large .ba-common-tile__footer{margin-top:12px;color:#161616}.ba-common-tile.is-large .ba-common-tile__footer__date{color:#161616}.ba-common-tile.is-large .ba-common-tags__listItem{padding:4px 8px !important;margin:16px 0px 0px 0px !important}[dir=rtl] .ba-common-tile__header__icon{padding-left:8px;padding-right:unset}[dir=rtl] .ba-common-tile__footer__icon{margin-right:16px;margin-left:unset}.ba-common-tile.is-container{background-color:#fff;height:64px}.ba-common-tile.is-container .ba-common-tile__left{color:#161616}.ba-common-tile.is-container .ba-common-tile__middle{color:#0f62fe}.ba-common-tile.is-container .ba-common-tile__middle__label{color:#0f62fe}.ba-common-tile.is-container .ba-common-tile__middle__date{color:#161616}.ba-common-tile.is-container .ba-common-tile__right{color:#161616}[dir=ltr] .ba-common-tile.is-container .ba-common-tile__middle,.ba-common-tile.is-container .ba-common-tile__middle{padding-left:16px}[dir=rtl] .ba-common-tile.is-container .ba-common-tile__middle{padding-right:16px;padding-left:unset}", ""]);

// exports
exports.locals = {
	"tileClassName": "\"ba-common-tile\""
};

/***/ }),

/***/ 63893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14777);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Tile_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 70001:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/folder_32");

/***/ }),

/***/ 16346:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32");

/***/ }),

/***/ 51443:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32");

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 37453:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37453__;

/***/ }),

/***/ 65391:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__65391__;

/***/ }),

/***/ 47511:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__47511__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(75002));
/******/ return __webpack_exports__;
/******/ }
]);
});